import { EvidenceChip } from "@/components/iv/scorecard/Bits";

const barColor = (s) => (s >= 7 ? "bg-emerald-400" : s >= 4.5 ? "bg-amber-400" : "bg-rose-400");

export const CriteriaMatrix = ({ scores }) => {
  const ordered = [...scores.filter((s) => s.criterion_group === "universal"), ...scores.filter((s) => s.criterion_group !== "universal")];
  return (
    <section aria-labelledby="matrix-title" data-testid="criteria-matrix">
      <h2 id="matrix-title" className="text-lg font-bold text-white">Complete 20-Parameter Stress-Test Matrix</h2>
      <p className="mb-3 text-xs text-slate-400">Zero hidden criteria: 12 Universal + 8 Specialist Overlay, weights normalised to 100.</p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {ordered.map((c, i) => {
          const uni = c.criterion_group === "universal";
          return (
            <article key={c.criterion_key} className={`iv-glass flex h-full min-w-0 flex-col gap-2 rounded-xl p-3.5 ${c.fatal_flaw_triggered ? "!border-rose-400/60" : ""}`} data-testid={`criterion-card-${i + 1}`}>
              <div className="flex items-center justify-between gap-2">
                <span className={`rounded-md px-2 py-0.5 text-[10px] font-bold ${uni ? "bg-blue-500/15 text-blue-300" : "bg-violet-500/15 text-violet-300"}`}>{uni ? "Universal" : "Specialist Overlay"}</span>
                <span className="font-mono text-[10px] text-slate-400">{c.normalized_weight.toFixed(2)}% weight</span>
              </div>
              <h3 className="text-sm font-bold leading-snug text-white">{i + 1}. {c.name}</h3>
              <p className="text-xs leading-relaxed text-slate-300">{c.analyst_note || c.evidence}</p>
              {c.fatal_flaw_triggered && <p className="text-[10px] font-bold text-rose-300">Fatal-flaw trigger</p>}
              <div className="mt-auto space-y-2 pt-1">
                <div className="flex items-center justify-between">
                  <span className="rounded-full border border-white/10 px-2 py-0.5 font-mono text-xs font-bold text-white" data-testid={`criterion-card-${i + 1}-score`}>{c.score.toFixed(1)} / 10</span>
                  <span className="font-mono text-xs text-cyan-300" data-testid={`criterion-card-${i + 1}-points`}>+{c.weighted_contribution.toFixed(2)} pts</span>
                </div>
                <div className="h-1.5 rounded-full bg-white/[0.06]"><div className={`h-1.5 rounded-full ${barColor(c.score)}`} style={{ width: `${c.score * 10}%` }} /></div>
                <EvidenceChip type={c.evidence_type} citation={c.source_citation} date={c.source_date} url={c.source_url} testId={`criterion-card-${i + 1}-evidence`} />
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};
